
import React, { useEffect, useState } from 'react';

const PackagesTabs = (props) => {

    return (<div className='packages-tabs-wrapper'>
        <span role='button' className={`${props.selectedTab == 'newPackages' ? 'selected-tab' : ''} tab`} onClick={() => props.onSelectedTab('newPackages')}>חבילות לרכישה</span>
        <span role='button' className={`${props.selectedTab == 'existingPackages' ? 'selected-tab' : ''} tab`} onClick={() => props.onSelectedTab('existingPackages')}>החבילות שלכם</span>
    </div>);

}
export default PackagesTabs;
